<template>
  <vuex-table :fields="fields" :auto_start="false" table_store="phone-number/numbers/table">
    <template slot="status" slot-scope="{ item }">
      <status-badge :value="item.status" />
      <div class="text-grey">{{ getDate(item) }}</div>
    </template>

    <template slot="is_spam" slot-scope="{ item }">
      <is-spam-badge :value="item.is_spam" />
    </template>

    <template slot="number" slot-scope="{ item }">
      <div>{{ item.number }}</div>
      <div class="mt-1 text-grey flex flex-col-end" style="font-size: 12px">
        <img class="mr-1 table-flag-icon" :src="getFlagUrl(item.country_name)" />
        {{ item.country_name }}
      </div>
    </template>

    <template slot="allow_sms" slot-scope="{ item }">
      <boolean-state :value="item.allow_sms" />
    </template>

    <template slot="subscription_fee" slot-scope="{ item }">
      {{ $numeral.currency(item.subscription_fee) }}

      <div class="text-grey">{{ getDaysUntilPayment(item.activated_at) }}</div>
    </template>

    <template slot="state" slot-scope="{ formatted: value }">
      <state-badge :value="value" />
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span
          v-if="item.is_allow_direction_to_pbx"
          class="dropdown-item-icon dropdown-item-icon--config"
          @click="connect_pbx(item)"
        >
          {{ $t('phone-number.number.action.connect_pbx') }}
        </span>

        <span class="dropdown-item-icon dropdown-item-icon--stats" @click="showStats(item)">
          {{ $t('phone-number.number.action.stats') }}
        </span>

        <span class="dropdown-item-icon dropdown-item-icon--trash" @click="deactivate(item)">
          {{ $t('phone-number.number.action.deactivate') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions } from 'vuex';
  import StatusBadge from '@phone-number/components/numbers-badge-status';
  import StateBadge from '@phone-number/components/numbers-badge-state';
  import IsSpamBadge from '@phone-number/components/numbers-badge-is-spam';
  import BooleanState from '@shared/components/icon/icon-item-state';
  import { NumberModalService } from '@phone-number/modals/NumberModalService';
  import { toUserDateWithTime, daysUntilPaymentExpiration } from '@shared/helpers/date_format';
  import { mapGetters } from 'vuex';

  export default {
    components: { StatusBadge, IsSpamBadge, BooleanState, StateBadge },
    computed: {
      ...mapGetters('phone-number/user_countries/list', ['countries', 'isLoading']),
      fields: function () {
        return [
          {
            key: 'number',
            label: this.$t('phone-number.number.field.number'),
            sortable: true,
            class: 'column-sticky',
            thStyle: {
              minWidth: '180px'
            }
          },

          {
            key: 'status',
            label: this.$t('phone-number.number.field.current_status'),
            sortable: false,
            thStyle: {
              minWidth: '170px'
            }
          },
          {
            key: 'activated_at',
            label: this.$t('phone-number.number.field.activated_at'),
            formatter: (value) => (value ? toUserDateWithTime(value) : ''),
            sortable: false,
            class: 'table-created_at'
          },

          {
            key: 'connection_cost',
            label: this.$t('phone-number.number.field.connection_cost'),
            sortable: false,
            formatter: (val) => this.$numeral.currency(val),
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'subscription_fee',
            label: this.$t('phone-number.number.field.subscription_fee'),
            sortable: false,
            formatter: (val) => this.$numeral.currency(val),
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'allow_sms',
            label: this.$t('phone-number.number.field.allow_sms'),
            sortable: false,
            thStyle: {
              minWidth: '100px'
            }
          },

          {
            key: 'state',
            label: this.$t('phone-number.number.field.state'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'type',
            label: this.$t('phone-number.number.field.type'),
            sortable: false,
            formatter: (val) => this.$t(`phone-number.number.type.${val}`),
            thStyle: {
              minWidth: '100px'
            }
          },

          {
            key: 'is_spam',
            label: this.$t('phone-number.number.field.is_spam'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'table-actions'
          }
        ];
      }
    },

    methods: {
      ...mapActions('phone-number/numbers/table', ['getAsyncData']),

      isoCodeByName: function (country_name) {
        return this.countries.find((i) => i.country === country_name)?.iso;
      },

      getFlagUrl: function (country_name) {
        const isoCode = this.isoCodeByName(country_name);

        if (isoCode) {
          return `https://flagsapi.com/${isoCode.toUpperCase()}/flat/32.png`;
        } else {
          return '';
        }
      },

      getDate(item) {
        // const { status, deactivated_at } = item;

        if (status === 'on_deactivated') {
          // на деактивации вывести дату только {{deactivated_at}}
        } else if (status === 'deactivated') {
          // деактивирован вывести дату только {{deactivated}}
        }
      },

      deactivate: function (item) {
        return NumberModalService.deactivate(item.id, item).on('success', () =>
          this.getAsyncData()
        );
      },

      getDaysUntilPayment(activatedDate) {
        let days = daysUntilPaymentExpiration(activatedDate);
        return this.$tc('phone-number.number.days_until_payment', days);
      },

      showStats: function (item) {
        this.$router.push({
          name: 'phone-number.stats.index',
          params: { number: item.number }
        });
      },

      connect_pbx: function (item) {
        return NumberModalService.connect_pbx(item.id, item).on('success', () =>
          this.getAsyncData()
        );
      }
    }
  };
</script>
